import {Injectable, Type} from "@angular/core";
import {GenericResourceSummaryComponent} from "./generic-resource-summary.component";
import {IResourceSummaryComponent} from "./resource-summary.component";
import {DeviceSummaryComponent} from "../device/device-summary.component";
import {StateSummaryComponent} from "../state/statesummary.component";
import {DeviceSlotSummaryComponent} from "../device/deviceslot-summary.component";
import {SlotReservationSummaryComponent} from "../slots/slot-reservation-summary.component";
import {isDefined} from '../../utils/utils';
import {DeployableGroupComponent} from "@webmate-web-core/shared/components/device/deployable-group.component";

export class ResourceFactory {

    constructor(public additionalCreators?: any){
        if (isDefined(additionalCreators)) {
            for (let k in additionalCreators) {
                this.resourceCreators[k] = additionalCreators[k];
            }
        }
    }

    private resourceCreators = {
        // unfortunately, it seems that typescript does not allow enum values as index signature, hence we have to stringify the enum.
        'state': {
            'Summary': () => StateSummaryComponent
        },
        'device': {
            'Summary': () => DeviceSummaryComponent
        },
        'deviceSlot': {
            'Summary': () => DeviceSlotSummaryComponent
        },
        'template': {
            'Summary': () => DeployableGroupComponent
        },
        'reservation': {
            'Summary': () => SlotReservationSummaryComponent
        },
        'default': {
            'Summary': () => GenericResourceSummaryComponent,
        }
    };

    makeResourceSummaryComponent(resourceType: string): Type<IResourceSummaryComponent> {
        if (this.resourceCreators.hasOwnProperty(resourceType)) {
            return this.resourceCreators[resourceType]['Summary']();
        } else {
            return this.resourceCreators['default']['Summary']();
        }
    }
}
